import BaseService from "./BaseService";

class AIWrapperService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  fetchAICompanyPlan = async (companyId: string): Promise<any> => {
    try {
      let url = `/plan/company?companyId=${companyId}`;
      const res = await this.requests.get(url);
      if(res) { // check if it's set to disabled or not
        return res
      }
    } catch (err) {
      console.log(err)
      return null
    }
  }

  fetchFeatureFlags = async (companyId: string): Promise<any> => {
    try {
      console.log('fetchFeatureFlags', companyId)
      let url = `/plan/feature-flags?companyId=${companyId}`;
      const res = await this.requests.get(url);
      console.log('fetchFeatureFlags', res)
      res.LastSyncedAt = new Date().toISOString()
      return res
    } catch (err) {
      console.log(err)
      return null
    }
  }

  isSummerOfAIOptinForLocation = async (locationId: string, routePathParams: any): Promise<any> => {
    try {
      let url = `/plan/location?locationId=${locationId}`;
      const res = await this.requests.get(url, {
        headers: routePathParams
      });
      if(res) {
        return res
      }
      return null
    } catch (err) {
      console.log(err)
      return null
    }
  }
}

const instance = new AIWrapperService(BaseService.servicesConfig.AiWrapper)
export default instance
